import { z } from 'zod'
import type { PaginatedResponse } from './common'

export const createLessonCompletionSchema = z.object({
  lesson_id: z.string().min(1),
  course_id: z.string().min(1),
  completed_at: z.string().datetime().optional(),
})

export type CreateLessonCompletionInput = z.infer<
  typeof createLessonCompletionSchema
>

export type LessonCompletionResponse = {
  id: string
  legacy_id?: string | null
  user_email: string
  lesson_id: string
  lesson_domain_id: string
  course_id: string
  course_domain_id: string
  completed_at: string
  created_at: string
  updated_at: string
}

export type PaginatedLessonCompletionResponse =
  PaginatedResponse<LessonCompletionResponse>
